import { useEffect } from "react";
import { useJsApiLoader } from "@react-google-maps/api";
import { useDispatch } from "react-redux";
import { setGoogleStatus } from "./store/app/general";

interface GoogleMapsProviderProps {
  apiKey: string;
}

function GoogleMapsProvider({ apiKey }: GoogleMapsProviderProps) {
  const dispatch = useDispatch();

  const { isLoaded, loadError } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: apiKey,
  });

  useEffect(() => {
    window.gm_authFailure = () => {
      dispatch(setGoogleStatus(false));
    };
    return () => {
      delete window.gm_authFailure;
    };
  }, [dispatch]);

  useEffect(() => {
    if (!apiKey || apiKey.trim() === "") {
      dispatch(setGoogleStatus(false));
      return;
    }
    if (loadError) {
      dispatch(setGoogleStatus(false));
      return;
    }
    if (isLoaded) {
      dispatch(setGoogleStatus(true));
    }
  }, [isLoaded, loadError, apiKey, dispatch]);

  return null; // Rendert nichts, nur Side-Effects
}

export default GoogleMapsProvider;
